import React, { ReactElement } from 'react';

import { Drawer, Props } from '~shared/components/Drawer';
import { useMedia } from '~shared/hooks';

type SidebarProps = Pick<Props, 'onClose' | 'open' | 'title'> & {
  children: ReactElement;
};

/**
 * Conditionally wraps a sidebar's DOM children in a Drawer component when on a
 * mobile-sized screen.
 */
export function Sidebar({ children, ...props }: SidebarProps) {
  const showDrawer = useMedia(['(max-width: 1023px)'], [true], false);

  return showDrawer ? (
    <Drawer
      id="quizzes-drawer"
      position="left"
      size="content"
      hasCustomCloseButton
      {...props}
    >
      {(headerProps) => (
        <div className="p-4 pt-5">
          <header className="flex items-center h-14 px-5">
            <h1
              className="m-0 font-display text-lg font-700 leading-14 text-blue-900 capsize"
              ref={headerProps.headingRef}
            >
              {headerProps.title}
            </h1>
          </header>
          {children}
        </div>
      )}
    </Drawer>
  ) : (
    children
  );
}
